import { ReactComponent as TickMark } from '../../assets/svgs/DesignSystem/tick-mark.svg';
import PropTypes from 'prop-types';

const isCurrentStep = (currentStep, index) => currentStep >= index;
const stepCompleted = (currentStep, index) => currentStep > index;

const Stepper = ({ steps, currentStep }) => {
  return (
	<div className="ds-stepper__wrapper">
		{steps.length
			? steps.map((step, index) => {
					const { stepTitle, subStepTitle } = step;

					return (
						<div
							key={index}
							className={`ds-stepper__item ${isCurrentStep(currentStep, index) ? 'ds-stepper__item--current-step' : ''} ${
								stepCompleted(currentStep, index)
									? 'ds-stepper__item--completed'
									: ''
							}`}
						>
							<div className="ds-stepper__counter">
								{stepCompleted(currentStep, index) ? (
									<span data-testid="tick-mark">
										<TickMark />
									</span>
								) : (
									index + 1
								)}
							</div>
							<div className="ds-stepper__text-container">
								<div className="ds-stepper__title">
									{stepTitle}
								</div>
								<div className="ds-stepper__title ds-stepper__title--sub-step">
									{subStepTitle}
								</div>
							</div>
						</div>
					);
				})
			: null}
	</div>
  );
};

Stepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepTitle: PropTypes.string.isRequired,
      subStepTitle: PropTypes.string,
    })
  ).isRequired,
  currentStep: PropTypes.number.isRequired,
};

export default Stepper;
